import React from 'react';

import Home from './Home';

import './home.less';

const HomeDashboard = ({ context }) => (
  <Home context={context} dashboard="HomePageFrontoffice" translation="home" />
);

export default HomeDashboard;
